// @flow

import React from 'react';
import glamorous from 'glamorous';

const SelectedUnderline = glamorous.div(({ theme, spartan }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: 3,
  backgroundColor: spartan ? theme.color.spartanBlue : theme.color.primary,
  transition: 'all 0.3s ease-out',
}));

const RelativeDiv = glamorous.div({
  position: 'relative',
  display: 'flex',
  width: '100%',
});

type Props = {
  children?: any,
  selectedIndex: number,
  spartan?: boolean,
};

const defaultProps = {
  children: null,
  spartan: false,
};

function LightTabSet({ selectedIndex, children, spartan }: Props) {
  const underlineStyle = {
    transform: `translateX(${selectedIndex * 100}%)`,
    width: `${100 / React.Children.toArray(children).length}%`,
    opacity: selectedIndex >= 0 ? 1 : 0,
  };

  return (
    <RelativeDiv>
      {children}
      <SelectedUnderline style={underlineStyle} spartan={spartan} />
    </RelativeDiv>
  );
}

LightTabSet.defaultProps = defaultProps;

export default LightTabSet;
